import React from 'react'
import './SimpleModal.scss'

const SimpleModal = ({
  isOpen,
  onClose,
  children,
  className = '',
  columns, // e.g., [50,50] or "40/60"
  left,
  right,
  gap = 0,
  style = {},
}) => {
  if (!isOpen) return null

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      if (document.querySelector('.ReactModal__Overlay')) {
        return
      }
      onClose()
    }
  }

  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  // Normalizar columnas
  let leftBasis
  let rightBasis
  if (columns) {
    if (Array.isArray(columns) && columns.length === 2) {
      leftBasis = `${columns[0]}%`
      rightBasis = `${columns[1]}%`
    } else if (typeof columns === 'string' && columns.includes('/')) {
      const [l, r] = columns.split('/').map((v) => parseInt(v.trim(), 10))
      if (!isNaN(l) && !isNaN(r)) {
        leftBasis = `${l}%`
        rightBasis = `${r}%`
      }
    }
  }

  const hasTwoCols = (left || right) && leftBasis && rightBasis

  return (
    <div className="simple-modal-backdrop" onClick={handleBackdropClick}>
      <div className={`simple-modal ${className}`} style={style}>
        <button
          className="simple-modal-close"
          onClick={onClose}
          aria-label="Cerrar modal"
        >
          ×
        </button>

        {hasTwoCols ? (
          <div
            className="simple-modal__content"
            style={{ gap: `${gap}px` }}
          >
            <div
              className="simple-modal__col simple-modal__col--left"
              style={{ flexBasis: leftBasis }}
            >
              {left}
            </div>
            <div
              className="simple-modal__col simple-modal__col--right"
              style={{ flexBasis: rightBasis }}
            >
              {right}
            </div>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  )
}

export default SimpleModal

